module.exports = __webpack_public_path__ + "static/media/campaigns-task.66b59e91.png";